var _path, _path2, _mask, _path3, _mask2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookademoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 89,
    viewBox: "0 0 173 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8783 21.1342C56.8783 32.2694 48.0534 41.2582 37.2138 41.2582C26.3742 41.2582 17.5493 32.2694 17.5493 21.1342C17.5493 9.999 26.3742 1.01025 37.2138 1.01025C48.0534 1.01025 56.8783 9.999 56.8783 21.1342Z",
    stroke: "#404041",
    strokeWidth: 2.02049
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.199 21.1342C155.199 32.2694 146.374 41.2582 135.535 41.2582C124.695 41.2582 115.87 32.2694 115.87 21.1342C115.87 9.999 124.695 1.01025 135.535 1.01025C146.374 1.01025 155.199 9.999 155.199 21.1342Z",
    stroke: "#404041",
    strokeWidth: 2.02049
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1536_6194",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 88.8329H74.4287C71.1242 62.3209 55.7192 42.2646 37.2144 42.2646C18.7095 42.2646 3.30458 62.3209 0 88.8329Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 88.8329L-2.00498 88.583L-2.28797 90.8534H0V88.8329ZM74.4287 88.8329V90.8534H76.7167L76.4337 88.583L74.4287 88.8329ZM0 90.8534H74.4287V86.8124H0V90.8534ZM37.2144 44.2851C45.6821 44.2851 53.6252 48.8685 59.9361 56.8591C66.247 64.8497 70.8089 76.1273 72.4237 89.0828L76.4337 88.583C74.744 75.0265 69.9512 63.02 63.1073 54.3545C56.2633 45.6889 47.2515 40.2442 37.2144 40.2442V44.2851ZM2.00498 89.0828C3.61981 76.1273 8.18176 64.8497 14.4927 56.8591C20.8035 48.8685 28.7466 44.2851 37.2144 44.2851V40.2442C27.1773 40.2442 18.1654 45.6889 11.3215 54.3545C4.47756 63.02 -0.315233 75.0265 -2.00498 88.583L2.00498 89.0828Z",
    fill: "#404041",
    mask: "url(#path-3-inside-1_1536_6194)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_1536_6194",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3193 88.8329H172.748C169.443 62.3209 154.039 42.2646 135.534 42.2646C117.029 42.2646 101.624 62.3209 98.3193 88.8329Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3193 88.8329L96.3144 88.583L96.0314 90.8534H98.3193V88.8329ZM172.748 88.8329V90.8534H175.036L174.753 88.583L172.748 88.8329ZM98.3193 90.8534H172.748V86.8124H98.3193V90.8534ZM135.534 44.2851C144.001 44.2851 151.945 48.8685 158.255 56.8591C164.566 64.8497 169.128 76.1273 170.743 89.0828L174.753 88.583C173.063 75.0265 168.271 63.02 161.427 54.3545C154.583 45.6889 145.571 40.2442 135.534 40.2442V44.2851ZM100.324 89.0828C101.939 76.1273 106.501 64.8497 112.812 56.8591C119.123 48.8685 127.066 44.2851 135.534 44.2851V40.2442C125.497 40.2442 116.485 45.6889 109.641 54.3545C102.797 63.02 98.0041 75.0265 96.3144 88.583L100.324 89.0828Z",
    fill: "#404041",
    mask: "url(#path-5-inside-2_1536_6194)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookademoSvg);
export default __webpack_public_path__ + "static/media/book a demoSVG.93d46f0f82c6b18370ac2caa5025234f.svg";
export { ForwardRef as ReactComponent };